export class ProtectionPlaceParent {
  constructor() {
    this.list = []
  }

  addProtectionPlace(item) {
    this.list.push(ProtectionPlace.buildFromAPI(item))
  }

  updateProtectionPlace(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, ProtectionPlace.buildFromAPI(item))
  }

  removeProtectionPlace(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => ProtectionPlace.buildFromAPI(el))
    }
    return this
  }
}

export class ProtectionPlace {
  constructor() {
    this.id = null
    this.fullName = null
    this.isActual = true
  }

  getForAPI() {
    return {
      id: this.id,
      fullName: this.fullName,
      isActual: this.isActual
    }
  }

  static buildFromAPI(obj) {
    const _this = new ProtectionPlace()
    if (obj) {
      _this.id = obj.id
      _this.fullName = obj.fullName
      _this.isActual = obj.id ? obj.isActual : true
    }
    return _this
  }
}
